import { render, staticRenderFns } from "./HomeBoxGuideBook.vue?vue&type=template&id=c174d78e"
import script from "./HomeBoxGuideBook.vue?vue&type=script&lang=js"
export * from "./HomeBoxGuideBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports